<div class="filtro justify-between border border-solid rounded border-gray-300 dark:border-gray-500 p-2 m-2 text-base font-semibold uppercase text-gray-600 dark:text-white items-center">
  <div class="grid grid-cols-4 gap-4" [formGroup]="corteForm">
    <div>
      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center">Plaza de cobro</div>
      <select (change)="getCaseta()" class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700" formControlName="caseta">
        <option value="" disabled>Seleccione una caseta</option>
        <option *ngFor="let caseta of casetas" value="{{ caseta.id }}">{{ caseta.nombre}}</option>
      </select>

    </div>
    <div>
      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center" >turno</div>
      <select class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700" (change)="getCortes()" name="" id="" formControlName="turno">
        <option value="" selected disabled>Seleccionar turno</option>
        <option *ngFor="let turno of turnos" value="{{ turno.id }}">{{ turno.turno }}</option>
      </select>
    </div>
    <div>
      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center" >fecha</div>
      <input type="date" (change)="getCortes()" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full" formControlName="fecha" >
    </div>
    <div>
      <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center">Corte</div>
      <select class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700" formControlName="corte">
        <option value="" selected disabled>Seleccionar corte</option>
        <option *ngFor="let corte of cortesDB" value="{{ corte.id}}">{{ corte.id }}:{{ corte.carril.nombre }}-{{corte.usuario.nombre}}</option>
      </select>
    </div>

    <div class="grid grid-cols-3 gap-4 col-span-2">
      <button class="estilo-dark dark:text-gray-100 dark:bg-blue-600 " (click)="abrirCarril()">Agregar</button>
    </div>
    <div class="grid grid-cols-2 gap-4 col-span-2">
      <button class="estilo-dark dark:text-gray-100 dark:bg-blue-600 " (click)="buscar()">buscar</button>
      <div class="dropdown">
        <button class="mt-2 appearance-none block p-3 mb-4 text-sm font-semibold uppercase bg-clip-padding bg-no-repeat transition ease-in-out m-0 btn btn-success w-full">Exportar</button>
        <div class="dropdown-content">
          <a (click)="exportar(1)">Incidencias</a>
          <a (click)="exportar(2)">Exentos</a>
          <a (click)="exportar(3)">Corte de Caja</a>
          <a (click)="exportar(4)">Retiros Parciales</a>
        </div>
      </div>
    </div>
  </div>

</div>
<hr class="mb-2 dark:border-gray-500">
<div class="dark:text-gray-100 dark:bg-transparent grid grid-rows-1 grid-flow-col gap-4">

  <div class="tab" (click)="setOpenTab(1)" [ngClass]="{' bg-navy ': openTab !== 1, ' active bg-blue-600 ': openTab === 1}">Incidencias</div>
  <div class="tab" (click)="setOpenTab(2)" [ngClass]="{' bg-navy ': openTab !== 2, ' active bg-blue-600 ': openTab === 2}">Exentos</div>
  <div class="tab" (click)="setOpenTab(3)" [ngClass]="{' bg-navy ': openTab !== 3, ' active bg-blue-600 ': openTab === 3}">Corte de Caja</div>
  <div class="tab" (click)="setOpenTab(4)" [ngClass]="{' bg-navy ': openTab !== 4, ' active bg-blue-600 ': openTab === 4}">Retiros Parciales</div>
</div>
<br>
<div>
  <!-- <div class="relative">
      <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
          <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"/>
          </svg>
      </div>
      <input type="search" id="default-search" class="search" placeholder="Buscar...">
  </div> -->
</div>
<br>
<div [ngClass]="{'hidden': openTab !== 1, 'block': openTab === 1}" class="mb-2 p-1 w-full border rounded border-solid border-gray-300 dark:border-gray-500
font-semibold text-base text-gray-500 dark:text-gray-200">
  <ngx-datatable class="material bord" [limit]="10" [rows]="incidencias" rowHeight="auto" [rowClass]="getRowClass"
    [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true">
    <ngx-datatable-column name="Hora" prop="hora" class="bord">
      <ng-template let-rowIndex='rowIndex' let-value="value" let-row="row" ngx-datatable-cell-template >
        <p>{{ value | date: 'HH:mm:ss' }}</p>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Concepto" prop="concepto">
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        {{ value || "Sin concepto" }}
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Tarifa" prop="tarifa">
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        {{ value || ( row.descripcion === 'Avienta dinero' ? row.avento_dinero : "Sin tarifa" ) }}
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Descripción" prop="descripcion">
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        {{ value }}, ${{ row.avento_dinero || "0" }}
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Observaciones" prop="observacion">
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        {{formateoObservacion(value)}}
      </ng-template>
    </ngx-datatable-column>
    <!-- Editar -->
    <ngx-datatable-column name="Acciones" prop="id">
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        <!-- Rounded switch -->
          <label class="switch">
            <input type="checkbox" (change)="openModelEdit(row, $event)" [checked]="row.observacion==null">
            <span class="slider round"></span>
          </label>
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
</div>
<div [ngClass]="{'hidden': openTab !== 2, 'block': openTab === 2}" class="mb-2 p-1 w-full border rounded border-solid border-gray-300 dark:border-gray-500
font-semibold text-base text-gray-500 dark:text-gray-200">
  <ngx-datatable class="material bord" [limit]="10" [rows]="exentos" rowHeight="auto"
    [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true">
    <ngx-datatable-column name="Hora" prop="hora" class="bord">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
        <p>{{ value | date: 'HH:mm:ss' }}</p>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Concepto" prop="concepto">
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        {{ value }}
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Tarifa" prop="tarifa">
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        {{ value  }}
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Observaciones" prop="observacion">
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        {{formateoObservacion(value)}}
      </ng-template>
    </ngx-datatable-column>
    <!-- Editar -->
    <ngx-datatable-column name="Acciones" prop="id">
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        <!-- Rounded switch -->
        <label class="switch">
          <input type="checkbox" (change)="openModelEdit(row, $event)" [checked]="row.observacion==null">
          <span class="slider round"></span>
        </label>

      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
</div>
<div [ngClass]="{'hidden': openTab !== 3, 'block': openTab === 3}" class="mb-2 p-1 w-full border rounded border-solid border-gray-300 dark:border-gray-500
font-semibold text-base text-gray-500 dark:text-gray-200">
<div class="flex flex-row space-x-4 text-blue-700 text-center text-xs">

  <div class="flex flex-col flex-1 space-y-4">

      <span class="bg-blue-200 rounded-md p-2 font-bold">
          Folio de boletos consumidos
      </span>

      <table class="text-center text-gray-600 dark:text-gray-300">
          <thead>
              <tr>
                  <th scope="col" class="pb-2">No.</th>
                  <th scope="col" class="pb-2">Inicia</th>
                  <th scope="col" class="pb-2">Final</th>
                  <th scope="col" class="pb-2">Totales</th>
              </tr>
          </thead>
          <tbody>
              <tr *ngFor="let rollo of rollos">
                  <td>{{ rollo.rollo }}</td>
                  <td>{{ rollo.folio_inicial }}</td>
                  <td>{{ rollo.folio_final }}</td>
                  <td>{{ (rollo.folio_final - rollo.folio_inicial) + 1 }}</td>
              </tr>
          </tbody>
      </table>

      <span class="bg-blue-200 rounded-md p-2 font-bold">
          Recepcion del fondo inicial
      </span>

      <div class="flex justify-around text-gray-600 dark:text-gray-300">
          <span>Recibe fondo cobrador</span>
          <span>${{ fondoCobrador | number }}</span>
      </div>

      <span class="bg-blue-200 rounded-md p-2 font-bold">
          Concentrado de aforo
      </span>

      <div class="flex flex-row justify-around text-gray-600 dark:text-gray-300">

          <div class="flex flex-col">
              <span>Aforo pagado</span>
              <span>Boletos recibidos</span>
              <span>Exentos / Residentes</span>
              <span>Eludidos</span>
              <span>Aforo total</span>
          </div>

          <div class="flex flex-col">
              <span>{{ aforoTotal }}</span>
              <span>{{ boletoRecibido }}</span>
              <span>{{ exentoResidente }}</span>
              <span>{{ eludido }}</span>
              <span>{{ aforoFinal }}</span>
          </div>

      </div>

  </div>

  <div class="flex flex-col flex-1 space-y-4">

      <span class="bg-blue-200 rounded-md p-2 font-bold">
          Resumen de folios consumidos
      </span>

      <div class="flex flex-row justify-around text-gray-600 dark:text-gray-300">

          <div class="flex flex-col">
              <span>Total de boletos</span>
              <span>+ Boletos no emitidos</span>
              <span>- Boletos cancelados</span>
              <span>Total de aforo</span>
          </div>

          <div class="flex flex-col">
              <span>{{ folioTotal }}</span>
              <span>{{ noEmitidos || 0 }}      ${{ montonoEmitidos || 0 }}</span>
              <span>{{ cancelados || 0 }}      ${{ montocancelados || 0 }}</span>
              <span>{{ aforoTotal | number }}</span>
          </div>

      </div>

      <span class="bg-blue-200 rounded-md p-2 font-bold">
          Resumen de efectivo
      </span>

      <div class="flex flex-row justify-around text-gray-600 dark:text-gray-300">

          <div class="flex flex-col">
              <span>Total de retiros parciales</span>
              <span>+ Ultimo efectivo</span>
              <span>Total recaudado</span>
          </div>

          <div *ngFor="let ef of efectivo" class="flex flex-col">
              <span>${{ ef.retiro_parcial || 0 | number }}</span>
              <span>${{ ef.ultimo_efectivo || 0 | number }}</span>
              <span>${{ (ef.retiro_parcial + ef.ultimo_efectivo) || 0 | number }}</span>
          </div>

      </div>

  </div>

</div>




</div>
<div [ngClass]="{'hidden': openTab !== 4, 'block': openTab === 4}" class="mb-2 p-1 w-full border rounded border-solid border-gray-300 dark:border-gray-500
font-semibold text-base text-gray-500 dark:text-gray-200">
  <ngx-datatable class="material bord" [limit]="10" [rows]="retiros" rowHeight="auto"
    [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true">
    <ngx-datatable-column name="Hora" prop="fecha_hora" class="bord">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template >
        <p>{{ value | date: 'HH:mm:ss' }}</p>
      </ng-template>
    </ngx-datatable-column>
    <ngx-datatable-column name="Importe" prop="importe">
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        {{ value }}
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
</div>
<br>


<div *ngIf="modalEdit" class="modal-component-container fixed inset-0 overflow-y-auto">
  <div class="modal-flex-container flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="modal-bg-container fixed inset-0 bg-gray-700 bg-opacity-75"></div>
      <div class="modal-space-container hidden sm:inline-block sm:align-middle sm:h-screen">&nbsp;</div>

      <div class="modal-container inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg w-full">

          <div class="modal-wrapper bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <div class="modal-wrapper-flex sm:flex sm:items-start">
                  <div class="modal-content mt-3 w-full sm:mt-0 sm:ml-0 sm:text-left space-y-3">
                      <div class="flex items-center justify-between">
                          <div class="flex items-center flex-col space-y-2 rounded py-1 w-full">
                            <div class="text-gray-500 font-bold text-base text-center">Plaza de cobro</div>
                            <div class="inline-flex align-items-center p-3" id="operacionesincidencias">
                              <div class="form-check">
                                <input type="checkbox" id="deshabilitarEdit" class="form-check-input p-5 padd" [(ngModel)] = "eventoEdit.habilitado">
                                <label class="form-check-label m-5 margg" for="incDeshabilitar">Deshabilitar</label>
                              </div>
                            </div>
                              <div class="grid grid-cols-3 grid-flow-row gap-4">
                                <button (click)="getSubDeteccion($event,'USUARIO','error')"
                                  class="error estilo-dark">
                                  USUARIO
                                </button>
                                <button (click)="getSubDeteccion($event,'SISTEMA','error')"
                                  class="error estilo-dark">
                                  SISTEMA
                                </button>
                                <button  (click)="getSubDeteccion($event,'COBRADOR','error')"
                                  class="error  estilo-dark">
                                  COBRADOR
                                </button>
                              </div>
                              <br>
                              <div>
                                <div>
                                  <span>Cambiar Incidencia/Clase</span>
                                </div>
                                <br>
                                <div id="clase" class="grid grid-cols-2 gap-4">
                                  <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center ">
                                    <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center">
                                      Clase
                                    </div>
                                    <ng-select id="clasificacionEdit" class = "w-full" [items]="clasificacionesEdit" bindLabel="tipo" bindValue="id" [(ngModel)]="eventoEdit.tarifaId">
                                    </ng-select>
                                  </div>
                                  <div class="">
                                    <div class = "text-gray-500 dark:text-gray-50 font-bold text-base text-center">
                                      Incidencia
                                    </div>
                                    <ng-select id="incidenciaEdit" class = "w-full" [items]="incidenciasEdit" bindLabel="nombre" bindValue="id" [(ngModel)]="eventoEdit.descripcionId">
                                    </ng-select>
                                  </div>
                                </div>
                              </div>
                              <br>
                              <textarea name="" id="observacionEdit"  rows="5" class="w-full border"></textarea>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div class="modal-actions bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">

            <button (click)="dismissModal(true)"
            class="w-full inline-flex justify-center bg-blue-600 rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3  font-medium text-white hover:bg-white hover:text-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                Guardar
            </button>
            <button (click)="dismissModal(false)"
            class="w-full inline-flex justify-center bg-red-600 rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3  font-medium text-white hover:bg-white hover:text-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                Cerrar
            </button>
          </div>

      </div>
  </div>
</div>

<div *ngIf="modalCarril" class="modal-component-container fixed inset-0 overflow-y-auto">
  <div class="modal-flex-container flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="modal-bg-container fixed inset-0 bg-gray-700 bg-opacity-75"></div>
      <div class="modal-space-container">&nbsp;</div>

      <div class="modal-container inline-block align-bottom  rounded-lg text-left overflow-hidden shadow-xl transform transition-all">

          <div class="modal-wrapper bg-gray-700 px-4 pt-5 pb-4 sm:p-6">
              <div class="modal-wrapper-flex ">
                  <div class="modal-content  w-full">
                    <div class="filtro justify-between border border-solid rounded border-gray-300 dark:border-gray-500 bg-gray-500 p-2 m-2 text-base font-semibold uppercase text-gray-600 dark:text-white items-center">
                      <div class="grid grid-cols-3 gap-4" [formGroup]="insertarEvento">
                        <div>
                          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center">Corte</div>
                              <select formControlName="id_corte_usuario"  class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700">
                                  <option value="" selected disabled>Seleccionar corte</option>
                                  <option *ngFor="let corte of cortesI" value="{{ corte.id }}">{{ corte.carril.nombre+"-"+corte.fecha_hora_fin }}{{ (corte.arqueo==1)?"-Arqueo":"" }}</option>
                              </select>
                        </div>
                        <div>
                          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center">Fecha Hora</div>
                              <input formControlName="fecha_hora"  class="w-full estilo-dark dark:text-gray-100 dark:bg-gray-700" type="datetime-local">
                        </div>
                        <div>
                          <div  class="text-gray-500 dark:text-gray-50 font-bold text-base text-center" >Concepto</div>
                          <select formControlName="id_cat_observacion" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                            <option value=null selected>N/A </option>
                            <option *ngFor="let grupo of subtipoPadres" value = "{{grupo.id}}">{{grupo.nombre}}</option>
                          </select>
                        </div>
                        <div>
                          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center" >tipo cruce</div>
                          <select formControlName="id_subtipo" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                            <option value=null selected>N/A </option>
                            <option *ngFor="let tipo of subtipoCruce" value="{{ tipo.id }}"> {{ tipo.nombre }}</option>
                          </select>
                        </div>
                        <div>
                          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center" >Clasificacion</div>
                          <select formControlName="id_clasificacion" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                            <option *ngFor="let clase of clasificacionesEdit" value="{{ clase.id }}"> {{ clase.tipo }}</option>
                          </select>
                        </div>
                        <div>
                          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center" >Ejes</div>
                          <select formControlName="cantidad_ejes" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                            <option value=null selected>N/A </option>
                            <option *ngFor="let eje of ejes" value="{{ eje.id }}">{{ eje.nombre }}</option>
                          </select>
                        </div>
                        <div>
                          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center" >avento dinero</div>
                          <input formControlName="aventoDinero" type="number" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full"  >
                        </div>
                        <div>
                          <div class="text-gray-500 dark:text-gray-50 font-bold text-base text-center" >Tarjeton</div>
                          <select formControlName="id_vehiculo_exe" class="estilo-dark rounded text-black  dark:text-gray-100 dark:bg-gray-700 bg-clip-padding border border-solid w-full">
                            <option value=null selected>N/A </option>
                            <option *ngFor="let tarjeton of actualExentos" value="{{ tarjeton.id }}">{{ tarjeton.no_tarjeton }} : {{tarjeton.persona?.nombre?.substring(0,21)}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
          </div>

          <div class="modal-actions bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">

            <button (click)="insertarEventoF()"
            class="w-full inline-flex justify-center bg-blue-600 rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3  font-medium text-white hover:text-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                Guardar
            </button>
            <button (click)="modalCarril=false"
            class="w-full inline-flex justify-center bg-red-600 rounded-md border border-gray-300 shadow-md px-4 py-2  mt-3  font-medium text-white hover:text-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-200 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
                Cerrar
            </button>
          </div>

      </div>
  </div>
</div>
